export default [
  {
    path: "/workers/list",
    name: "workers-list",
    component: () => import("@/views/worker/workers-list/workersList.vue"),
    meta: {
      action: "read",
      resource: "workers",
    },
  },
  {
    path: "/worker/view/:id",
    name: "worker-view",
    component: () => import("@/views/worker/worker-view/workerView.vue"),
    meta: {
      action: "view_detail",
      resource: "workers",
    },
  },
  {
    path: "/worker/edit/:id",
    name: "worker-edit",
    component: () => import("@/views/worker/worker-edit/workerEdit.vue"),
    meta: {
      action: "update",
      resource: "workers",
    },
  },
  {
    path: "/worker/create",
    name: "worker-create",
    component: () => import("@/views/worker/worker-edit/workerEdit.vue"),
    meta: {
      action: "create",
      resource: "workers",
    },
  },
  {
    path: "/worker/advance-payment/list",
    name: "worker-advance-payment-list",
    component: () => import("@/views/finance/advance-payment/advance-payments-list/advancePaymentsList.vue"),
    meta: {
      action: "read",
      resource: "user_prepayments",
    },
    props: (route) => ({ routeKey: route.name }),
  },
  {
    path: "/worker/advance-payment/view/:id",
    name: "worker-advance-payment-view",
    component: () => import("@/views/finance/advance-payment/advance-payment-view/advancePaymentView.vue"),
    meta: {
      action: "view_detail",
      resource: "user_prepayments",
    },
  },
  {
    path: "/worker/advance-payment/create",
    name: "worker-advance-payment-create",
    component: () => import("@/views/finance/advance-payment/advance-payment-edit/advancePaymentEdit.vue"),
    meta: {
      action: "create",
      resource: "user_prepayments",
    },
  },
  {
    path: "/worker/advance-payment/edit/:id",
    name: "worker-advance-payment-edit",
    component: () => import("@/views/finance/advance-payment/advance-payment-edit/advancePaymentEdit.vue"),
    meta: {
      action: "update",
      resource: "user_prepayments",
    },
  },
  {
    path: "/worker/claim/list",
    name: "worker-claim-list",
    component: () => import("@/views/finance/claim/claims-list/claimsList.vue"),
    meta: {
      action: "read",
      resource: "user_claims",
    },
    props: (route) => ({ routeKey: route.name }),
  },
  {
    path: "/worker/claim/create",
    name: "worker-claim-create",
    component: () => import("@/views/finance/claim/claims-edit/claimsEdit.vue"),
    meta: {
      action: "create",
      resource: "user_claims",
    },
  },
  {
    path: "/worker/claim/edit/:id",
    name: "worker-claim-edit",
    component: () => import("@/views/finance/claim/claims-edit/claimsEdit.vue"),
    meta: {
      action: "update",
      resource: "user_claims",
    },
  },
  {
    path: "/worker/salary/list",
    name: "worker-salary-list",
    component: () => import("@/views/worker/salary/salaries-list/salariesList.vue"),
    meta: {
      action: "read",
      resource: "user_salaries",
    },
    props: (route) => ({ routeKey: route.name }),
  },
  {
    path: "/worker/salary/preview/:id",
    name: "worker-salary-preview",
    component: () => import("@/views/worker/salary/salaries-preview/SalariesPreview.vue"),
    meta: {
      action: "print",
      resource: "user_salaries",
    },
  },
  {
    path: "/salaries/list",
    name: "salaries-list",
    component: () => import("@/views/worker/salary/salaries-list/salariesList.vue"),
    meta: {
      action: "read",
      resource: "salaries",
    },
    props: (route) => ({ routeKey: route.name }),
  },
  {
    path: "/salary/preview/:id",
    name: "salary-preview",
    component: () => import("@/views/worker/salary/salaries-preview/SalariesPreview.vue"),
    meta: {
      action: "print",
      resource: "salaries",
    },
  },
  {
    path: "/expenditure/salary/create",
    name: "expenditure-salary-create",
    component: () => import("@/views/finance/expenditure/expenditures-edit/expendituresEdit.vue"),
    meta: {
      action: "salaries_create",
      resource: "worker_detail",
    },
  },
  // {
  //   path: "/worker/salary/view/:id",
  //   name: "worker-salary-view",
  //   component: () => import("@/views/worker/salary/salary-view/salaryView.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "workers",
  //   },
  // },
  // {
  //   path: "/worker/salary/create",
  //   name: "worker-salary-create",
  //   component: () => import("@/views/worker/salary/salary-edit/salaryEdit.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "workers",
  //   },
  // },
  // {
  //   path: "/worker/salary/edit/:id",
  //   name: "worker-salary-edit",
  //   component: () => import("@/views/worker/salary/salary-edit/salaryEdit.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "workers",
  //   },
  // },


  {
    path: "/progress/list",
    name: "progress-list",
    component: () => import("@/views/progress/progress-list/progressList.vue"),
    meta: {
      action: "read",
      resource: "progresses",
    },
  },
  {
    path: "/progress/view/:id",
    name: "progress-view",
    component: () => import("@/views/progress/progress-view/progressView.vue"),
    meta: {
      action: "read",
      resource: "progresses",
    },
  },
  {
    path: "/progress/edit/:id",
    name: "progress-edit",
    component: () => import("@/views/progress/progress-edit/progressEdit.vue"),
    meta: {
      action: "update",
      resource: "progresses",
    },
  },
  {
    path: "/progress/create",
    name: "progress-create",
    component: () => import("@/views/progress/progress-edit/progressEdit.vue"),
    meta: {
      action: "create",
      resource: "progresses",
    },
  },
];

